

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { changeCurrencyApi, loginApi } from "../http/http";
import ModalInfo from "../components/ModalInfo";
import Loader from "../components/Loader";
import CongratsModal from "../components/CongratsModal";

const LoginPage = () => {
  const [msisdn, setMsisdn] = useState("");
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modalInfo, setModalInfo] = useState("");
  const [subscribeBtn, setSubscribeBtn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalType, setModalType] = useState("");
  const [message, setMessage] = useState({
    state: false,
    switchTo: "",
    stayWith: "",
    msisdn: "",
    pack: null,
  });

  const [currencyOptions] = useState([
    { value: "USD", label: "USD" },
    { value: "ZWG", label: "ZWG" },
  ]);

  const [selectedCurrency, setSelectedCurrency] = useState(null);
const [showCongrats, setShowCongrats] = useState(false);
const [rewardPoints, setRewardPoints] = useState(0);
  // ─── Helpers ────────────────────────────────────────────────────────────────

  const cleanPhoneNumber = (phone) => {
    let cleaned = phone.replace(/\D/g, "");
    if (cleaned.startsWith("263")) cleaned = cleaned.slice(3);
    if (cleaned.startsWith("0")) cleaned = cleaned.slice(1);
    return `263${cleaned}`;
  };

 const saveToLocalStorage = (data) => {
  if (data.redirectUrl) localStorage.setItem("redirectUrl", data.redirectUrl);
  if (data.token)       localStorage.setItem("token", data.token);
  if (data.pack)        localStorage.setItem("pack", data.pack);
  if (data.msisdn)      localStorage.setItem("msisdn", data.msisdn);
  if (data.currency)    localStorage.setItem("currency", data.currency);
  if (data.deviceId)    localStorage.setItem("deviceId", data.deviceId);  // ✅ added
  if (data.rewardsStatus !== undefined)
    localStorage.setItem("rewardsStatus", data.rewardsStatus);
  if (data.rewardsPoints)
    localStorage.setItem("rewardsPoints", data.rewardsPoints);
  if (data.canClaimRewards !== undefined)
    localStorage.setItem("canClaimRewards", data.canClaimRewards);
  if (data.canClaimPoints)
    localStorage.setItem("canClaimPoints", data.canClaimPoints);
};

  const generateDeviceId = () =>
    Math.floor(10000000 + Math.random() * 90000000).toString();

  const handleReset = () => {
    setMessage({ state: false, switchTo: "", stayWith: "", msisdn: "", pack: null });
  };

  const pressHandler = () => {
    setModal(false);
    setModalInfo("");
    setSubscribeBtn(false);
    if (modalType === "insufficientBalance") {
      handleReset();
      setMsisdn("");
      setSelectedCurrency(null);
      setModalType("");
    }
  };

  const navigateHandler = (path) => navigate(path);

//   const handleLoginSuccess = (responseData, currency, cleanedNumber) => {
//   const { message: redirectUrl, token, pack, rewardsStatus, rewardsPoints, canClaimRewards, canClaimPoints } = responseData;
  
//   saveToLocalStorage({ redirectUrl, token, pack, msisdn: cleanedNumber, currency, rewardsStatus, rewardsPoints, canClaimRewards, canClaimPoints });

//   if (rewardsStatus === true) {
//     setRewardPoints(rewardsPoints || 0);
//     setShowCongrats(true); // show modal, navigate on close
//   } else {
//     navigate("/auth"); // go directly
//   }
// };

  // ─── Submit (main login form) ────────────────────────────────────────────────


const handleLoginSuccess = (responseData, currency, cleanedNumber, deviceId) => {
  const { message: redirectUrl, token, pack, rewardsStatus, rewardsPoints, canClaimRewards, canClaimPoints } = responseData;

  saveToLocalStorage({ redirectUrl, token, pack, msisdn: cleanedNumber, currency, deviceId, rewardsStatus, rewardsPoints, canClaimRewards, canClaimPoints }); // ✅

  const isRewardTrue = rewardsStatus === true || rewardsStatus === "true";
  if (isRewardTrue) {
    setRewardPoints(rewardsPoints || 0);
    setShowCongrats(true);
  } else {
    navigate("/auth");
  }
};
  const submitHandler = async (e) => {
    e.preventDefault();

    if (!msisdn.trim() || !selectedCurrency) {
      setModal(true);
      setModalInfo("Input Fields cannot be empty!");
      return;
    }

    try {
      setLoading(true);
      const cleanedNumber = cleanPhoneNumber(msisdn);
      const deviceId = generateDeviceId();

      const response = await loginApi({
        msisdn: cleanedNumber,
        currency: selectedCurrency?.value,
        deviceId,
      });

 if (response?.status === 200) {
  handleLoginSuccess(response.data, selectedCurrency?.value, cleanedNumber, deviceId); // ✅
}
    } catch (error) {
      setLoading(false);
      const status = error?.response?.status;

      if (status === 403) {
        toast.error(error.response.data.message);
      } else if (status === 404) {
        setModal(true);
        setModalInfo(error.response.data.message);
        setSubscribeBtn(true);
      } else if (status === 409) {
        const pack = error?.response?.data?.pack;
        const optionUserIsSubscribed = currencyOptions.filter(
          (d) => d?.value !== selectedCurrency?.value
        );
        setMessage({
          state: true,
          switchTo: selectedCurrency?.value,
          stayWith: optionUserIsSubscribed[0]?.value || "",
          msisdn,
          pack,
        });
      } else {
        setModal(true);
        setModalInfo(
          error?.response?.data?.message || error?.message || "An unexpected error occurred."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  // ─── loginApiHandler (called after currency change) ─────────────────────────

  const loginApiHandler = async (currencyFromParam) => {
    try {
      setLoading(true);
      const cleanedNumber = cleanPhoneNumber(msisdn);
      const deviceId = generateDeviceId();

      const response = await loginApi({
        msisdn: cleanedNumber,
        currency: currencyFromParam,
        deviceId,
      });

      const responseData = response?.data;
      const responseStatus = response?.status;

      switch (responseStatus) {
        // case 200: {
        //   const { message: redirectUrl, token, pack, rewardsStatus, rewardsPoints, canClaimRewards, canClaimPoints } = responseData;
        //   saveToLocalStorage({
        //     redirectUrl,
        //     token,
        //     pack,
        //     msisdn: cleanedNumber,
        //     currency: currencyFromParam,
        //     rewardsStatus,
        //     rewardsPoints,
        //     canClaimRewards,
        //     canClaimPoints,
        //   });
        //   navigate("/auth");
        //   break;
        // }

   case 200: {
  handleLoginSuccess(responseData, currencyFromParam, cleanedNumber, deviceId); // ✅
  break;
}

        case 403:
          setModal(true);
          setModalInfo("You are not subscribed!");
          setSubscribeBtn(true);
          break;

        case 404:
          setModal(true);
          setModalInfo("User not found. Please subscribe to access services.");
          break;

        case 402:
          setModal(true);
          setModalInfo("Oops, you have insufficient balance!");
          break;

        case 409: {
          const optionUserIsSubscribed = currencyOptions.filter(
            (d) => d?.value !== selectedCurrency?.value
          );
          setMessage({
            state: true,
            switchTo: selectedCurrency?.value,
            stayWith: optionUserIsSubscribed[0]?.value || "",
            msisdn,
          });
          break;
        }

        default:
          setModal(true);
          setModalInfo("An unexpected error occurred.");
      }
    } catch (error) {
      const status = error?.response?.status;
      if (status === 403) {
        setModal(true);
        setModalInfo("You are not subscribed!");
        setSubscribeBtn(true);
      } else if (status === 404) {
        setModal(true);
        setModalInfo("Subscription not found. Please subscribe the services.");
        setSubscribeBtn(true);
      } else if (status === 402) {
        setModal(true);
        setModalInfo("Oops, you have insufficient balance!");
      } else if (status === 409) {
        const optionUserIsSubscribed = currencyOptions.filter(
          (d) => d?.value !== selectedCurrency?.value
        );
        setMessage({
          state: true,
          switchTo: selectedCurrency?.value,
          stayWith: optionUserIsSubscribed[0]?.value || "",
          msisdn,
        });
      } else {
        setModal(true);
        setModalInfo(
          error?.response?.data?.message || error?.message || "An unexpected error occurred."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  // ─── handleChangeCurrency (SWITCH TO new currency) ──────────────────────────

  // const handleChangeCurrency = async () => {
  //   try {
  //     setLoading(true);
  //     const cleanedNumber = cleanPhoneNumber(msisdn);
  //     const response = await changeCurrencyApi({
  //       msisdn: cleanedNumber,
  //       currency: message.switchTo,
  //     });

  //     if (response.status === 200 || response.status === 202) {
  //       // After currency change, call login again to get fresh token + redirectUrl
  //       await loginApiHandler(message.switchTo);
  //     } else {
  //       handlingResponseforChange(response);
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || "Something went wrong.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleChangeCurrency = async () => {
  try {
    setLoading(true);
    const cleanedNumber = cleanPhoneNumber(msisdn);
    const deviceId = generateDeviceId();

    const response = await changeCurrencyApi({
      msisdn: cleanedNumber,
      currency: message.switchTo,
    });

    if (response.status === 200 || response.status === 202) {
      localStorage.setItem("msisdn", cleanedNumber);
      localStorage.setItem("currency", message.switchTo);
      localStorage.setItem("deviceId", deviceId);

      navigate("/otp", {
        state: {
          msisdn: cleanedNumber,
          pack: message.pack,
          currency: message.switchTo,
          deviceId,
          fromSubscription: false,
        },
      });
    } else {
      handlingResponseforChange(response);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong.");
  } finally {
    setLoading(false);
  }
};

  // ─── handelwithsame (STAY WITH existing currency) ───────────────────────────

  const handelwithsame = async () => {
    try {
      setLoading(true);
      const cleanedNumber = cleanPhoneNumber(msisdn);
      const deviceId = generateDeviceId();

      const response = await loginApi({
        msisdn: cleanedNumber,
        currency: message.stayWith,
        deviceId,
      });

     if (response.status === 200) {
  handleLoginSuccess(response.data, message.stayWith, cleanedNumber, deviceId); // ✅
}
      else {
        setModal(true);
        setModalInfo(response?.data?.message || "An error occurred.");
      }
    } catch (error) {
      setModal(true);
      setModalInfo(error?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  // ─── handlingResponseforChange (fallback for changeCurrencyApi non-200) ─────

  const handlingResponseforChange = (response) => {
    const { status, data } = response;

    switch (status) {
      case 200:
      case 202:
        toast.success("Currency Changed successfully");
        setMessage({ state: false });
        loginApiHandler(message.switchTo);
        break;

      case 500:
        setLoading(false);
        navigate("/error");
        break;

      case 409: {
        setLoading(false);
        const optionUserIsSubscribed = currencyOptions.filter(
          (d) => d?.value !== selectedCurrency?.value
        );
        setMessage({
          state: true,
          switchTo: selectedCurrency?.value,
          stayWith: optionUserIsSubscribed[0]?.value || "",
          msisdn,
        });
        break;
      }

      case 404:
        setLoading(false);
        setModal(true);
        setModalInfo("An unexpected error occurred.");
        break;

      case 402:
        setLoading(false);
        toast.error(data);
        setModal(true);
        setModalInfo(data);
        setTimeout(() => navigate("/login"), 2000);
        break;

      case 403:
        setLoading(false);
        setModal(true);
        setModalType("insufficientBalance");
        setModalInfo(
          "Looks like your balance is low. Please top up your airtime to continue enjoying our service."
        );
        break;

      default:
        setLoading(false);
        break;
    }
  };

  // ─── Render ──────────────────────────────────────────────────────────────────

  return (
    <div className="min-h-screen bg-white flex flex-col md:block">

      {/* ── Mobile view ── */}
      <div className="md:hidden w-full max-w-[430px] min-h-screen bg-white flex flex-col pt-10 mx-auto">
        {message?.state === true ? (
          <div className="px-6 py-8 flex flex-col gap-5">
            <button
              onClick={handleReset}
              className="self-start text-2xl bg-transparent border-none text-black cursor-pointer"
            >
              &#8617;
            </button>
            <div className="flex flex-col gap-4 items-center">
              <p className="text-lg font-semibold text-center text-black">
                YOU ARE ALREADY SUBSCRIBED WITH {message.stayWith}
              </p>
              <p className="text-base text-center text-gray-300">DO YOU WISH TO:</p>
              <button
                type="button"
                disabled={loading}
                onClick={handleChangeCurrency}
                className="w-full py-4 bg-white text-[#1e2738] border-none rounded-xl text-base font-semibold cursor-pointer shadow-md"
              >
                {`SWITCH TO ${message.switchTo}`}
              </button>
              <button
                type="button"
                disabled={loading}
                onClick={handelwithsame}
                className="w-full py-4 bg-transparent text-black border border-gray-400 rounded-xl text-base font-semibold cursor-pointer"
              >
                {`STAY WITH ${message.stayWith}`}
              </button>
            </div>
          </div>
        ) : (
          <div className="px-6 py-8 flex justify-center items-center">
            <div className="h-[80vh] flex flex-col max-w-[320px] mx-auto w-full">
              <div className="flex items-center justify-between gap-4 mb-10 w-full px-2">
                <img
                  src="/yogamezxr.png"
                  style={{ mixBlendMode: "multiply" }}
                  className="h-8 sm:h-12 w-auto object-contain max-w-[45%]"
                  alt="YoGamesXR Logo"
                />
                <img
                  src="/assets/images/econet_logo.png"
                  className="h-8 sm:h-12 w-auto object-contain max-w-[45%]"
                  alt="Econet Logo"
                />
              </div>

              <div className="mb-8">
                <h1 className="text-[30px] font-bold text-[#3CB8D4] mb-2">Welcome back!</h1>
                <p className="text-black text-2xl font-bold">Login & continue.</p>
              </div>

              <form onSubmit={submitHandler} className="flex flex-col gap-6 mb-auto">
                <div className="flex flex-col gap-2">
                  <label className="text-xl font-normal text-black">Phone number</label>
                  <div className="relative flex items-center">
                    <span className="absolute left-4 text-base text-gray-500 pointer-events-none z-10">
                      +263
                    </span>
                    <input
                      type="tel"
                      placeholder="778106925"
                      value={msisdn}
                      onChange={(e) => setMsisdn(e.target.value)}
                      className="w-full py-4 pl-16 pr-12 text-base bg-[#D8DADC] text-black placeholder-gray-500 border-none rounded-lg outline-none"
                    />
                    {msisdn && (
                      <div className="absolute right-4 w-6 h-6 rounded-full bg-black flex items-center justify-center">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>

                {msisdn && (
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-normal text-black">Choose Currency</label>
                    <div className="flex gap-0 bg-[#E5E5E5] rounded-lg">
                      {currencyOptions.map((currency) => (
                        <button
                          key={currency.value}
                          type="button"
                          onClick={() => setSelectedCurrency(currency)}
                          className={`flex-1 py-3 rounded-md text-sm font-medium cursor-pointer transition-all ${
                            selectedCurrency?.value === currency.value
                              ? "bg-[#3CB8D4] text-black shadow-sm"
                              : "bg-transparent text-gray-600"
                          }`}
                        >
                          {currency.label}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  className="w-full py-4 bg-[#3CB8D4] text-black border-none rounded-lg text-base font-semibold cursor-pointer mt-auto"
                >
                  Login
                </button>
              </form>

              <div className="text-center text-xl text-black pt-8 pb-6">
                Don't have a subscription?{" "}
                <span
                  onClick={() => navigateHandler("/subscribe")}
                  className="text-[#010101] font-semibold cursor-pointer underline"
                >
                  Subscribe now
                </span>
              </div>
            </div>
          </div>
        )}

        {loading && <Loader />}
        {modal && (
          <ModalInfo
            text={modalInfo}
            pressHandler={pressHandler}
            subscribeBtn={subscribeBtn}
            msisdn={msisdn}
          />
        )}
      </div>

      {/* ── Desktop view ── */}
      <div className="hidden md:flex min-h-screen bg-white">
        {message?.state === true ? (
          <div className="w-full flex items-center justify-center">
            <div
              className="w-full px-8 py-12 flex flex-col gap-10"
              style={{ maxWidth: "clamp(300px, 30vw, 600px)" }}
            >
              <button
                onClick={handleReset}
                className="self-start text-2xl bg-transparent border-none text-black cursor-pointer"
              >
                &#8617;
              </button>
              <div className="flex flex-col gap-4 items-center">
                <p
                  style={{ fontSize: "clamp(13px, 1.2vw, 22px)" }}
                  className="font-semibold text-center text-black"
                >
                  YOU ARE ALREADY SUBSCRIBED WITH {message.stayWith}
                </p>
                <p
                  style={{ fontSize: "clamp(12px, 1vw, 18px)" }}
                  className="text-center text-gray-300"
                >
                  DO YOU WISH TO:
                </p>
                <button
                  type="button"
                  disabled={loading}
                  onClick={handleChangeCurrency}
                  style={{ fontSize: "clamp(12px, 1.1vw, 20px)" }}
                  className="w-full py-[1.5vh] bg-white text-[#1e2738] border-none rounded-xl font-semibold cursor-pointer shadow-md"
                >
                  {`SWITCH TO ${message.switchTo}`}
                </button>
                <button
                  type="button"
                  disabled={loading}
                  onClick={handelwithsame}
                  style={{ fontSize: "clamp(12px, 1.1vw, 20px)" }}
                  className="w-full py-[1.5vh] bg-transparent text-black border border-gray-400 rounded-xl font-semibold cursor-pointer"
                >
                  {`STAY WITH ${message.stayWith}`}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full flex flex-col py-[4vh]">
            <div
              className="flex items-center gap-8 mb-[3vh]"
              style={{ paddingLeft: "25%" }}
            >
              <img
                src="/yogamezxr.png"
                style={{ mixBlendMode: "multiply" }}
                className="h-12 md:h-16 w-auto object-contain max-w-[200px]"
                alt="YoGamesXR Logo"
              />
              <img
                src="/assets/images/econet_logo.png"
                className="h-12 md:h-16 w-auto object-contain max-w-[200px]"
                alt="Econet Logo"
              />
            </div>

            <div className="mb-[3vh]" style={{ paddingLeft: "25%" }}>
              <h1
                style={{ fontSize: "clamp(22px, 2.8vw, 52px)" }}
                className="font-bold text-[#3CB8D4] mb-1"
              >
                Welcome back!
              </h1>
              <p
                style={{ fontSize: "clamp(14px, 1.3vw, 26px)" }}
                className="text-black font-bold"
              >
                Login & continue.
              </p>
            </div>

            <div className="flex flex-col items-center w-full">
              <form
                onSubmit={submitHandler}
                className="flex flex-col"
                style={{
                  gap: "clamp(10px, 1.5vh, 24px)",
                  width: "clamp(220px, 20vw, 380px)",
                }}
              >
                <div className="flex flex-col gap-1">
                  <label
                    style={{ fontSize: "clamp(12px, 1vw, 18px)" }}
                    className="font-normal text-black"
                  >
                    Phone number
                  </label>
                  <div className="relative flex items-center">
                    <input
                      type="tel"
                      placeholder="0778106925"
                      value={msisdn}
                      onChange={(e) => setMsisdn(e.target.value)}
                      style={{
                        fontSize: "clamp(12px, 1vw, 18px)",
                        padding: "clamp(8px, 1.2vh, 16px) clamp(12px, 1vw, 20px)",
                      }}
                      className="w-full bg-[#E8E8E8] text-black placeholder-gray-500 border-none rounded-lg outline-none pr-10"
                    />
                    {msisdn && (
                      <span className="absolute right-3 bg-black rounded-full w-5 h-5 flex items-center justify-center">
                        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                      </span>
                    )}
                  </div>
                </div>

                {msisdn && (
                  <div className="flex flex-col gap-1">
                    <label
                      style={{ fontSize: "clamp(12px, 1vw, 18px)" }}
                      className="font-normal text-black"
                    >
                      Choose Currency
                    </label>
                    <div className="flex gap-0 bg-[#E5E5E5] rounded-lg overflow-hidden">
                      {currencyOptions.map((currency) => (
                        <button
                          key={currency.value}
                          type="button"
                          onClick={() => setSelectedCurrency(currency)}
                          style={{
                            fontSize: "clamp(12px, 1vw, 18px)",
                            padding: "clamp(8px, 1.2vh, 16px)",
                          }}
                          className={`flex-1 font-medium cursor-pointer transition-all ${
                            selectedCurrency?.value === currency.value
                              ? "bg-[#3CB8D4] text-black shadow-sm rounded-lg"
                              : "bg-transparent text-gray-600"
                          }`}
                        >
                          {currency.label}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  style={{
                    fontSize: "clamp(13px, 1.1vw, 20px)",
                    padding: "clamp(10px, 1.5vh, 18px)",
                  }}
                  className="w-full bg-[#3CB8D4] text-black border-none rounded-lg font-semibold cursor-pointer mt-2"
                >
                  Login
                </button>

                <div
                  style={{ fontSize: "clamp(12px, 1vw, 16px)" }}
                  className="text-center text-gray-500 pt-2"
                >
                  Don't have a subscription?{" "}
                  <span
                    onClick={() => navigateHandler("/subscribe")}
                    className="text-black font-semibold cursor-pointer underline"
                  >
                    Subscribe now
                  </span>
                </div>
              </form>
            </div>

            {loading && <Loader />}
          </div>
        )}

        {modal && (
          <ModalInfo
            text={modalInfo}
            pressHandler={pressHandler}
            subscribeBtn={subscribeBtn}
            msisdn={msisdn}
          />
        )}

     
      </div>
         <CongratsModal
  isOpen={showCongrats}
  points={rewardPoints}
  onClose={() => {
    setShowCongrats(false);
    navigate("/auth");
  }}
/>
    </div>
  );
};

export default LoginPage;

